export type AppTheme = typeof theme;

export const theme = {
  colours: {
    primary: "#66A3A3",
    secondary: "#F2F7F7",
  },
};
